import bcrypt from 'bcryptjs';
import config from '../config/config';

export function encryptStationPassword(plainPassword) {
  // if (!plainPassword) {
  //   throw new Error('Password field cannot be empty!');
  // }

  const algorithm = config.HASH_ALGO;
  const rounds = config.HASH_ROUND; 
  const manualSaltPart = config.STATION_SALT;
  
  // Validate required config values
  if (!algorithm) {
    throw new Error('HASH_ALGO configuration is missing!');
  }
  if (rounds === undefined || rounds === null) {
    throw new Error('HASH_ROUND configuration is missing!');
  }
  if (!manualSaltPart) {
    throw new Error('STATION_SALT configuration is missing!');
  }
  
  // Ensure rounds is a number
  const roundsNumber = typeof rounds === 'number' ? rounds : parseInt(rounds, 10);
  if (isNaN(roundsNumber)) {
    throw new Error('HASH_ROUND must be a valid number!');
  }
  
  const salt = `${algorithm}${roundsNumber.toString().padStart(2, '0')}$${manualSaltPart}`;
  const hash = bcrypt.hashSync(plainPassword, salt);
  return hash;
}